import React from 'react';
import PropTypes from 'prop-types';

const MagnifierIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
        <path d="M15.527 13.372l-3.344-3.318a6.474 6.474 0 001.023-3.5 6.6 6.6 0 10-6.6 6.553 6.6 6.6 0 003.374-.922l3.373 3.347a1.533 1.533 0 002.174-2.16zM2.047 6.553A4.557 4.557 0 116.6 11.074a4.545 4.545 0 01-4.553-4.521z" fill={fill} />
    </svg>
);

MagnifierIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

MagnifierIcon.defaultProps = {
    width: '16',
    height: '16',
    fill: '#4b254e'
};

export default MagnifierIcon;
